export interface IItem {
	title: string;
	url: string;
	preamble: string;
}

export interface ISort {
	name: string,
	title: string,
}


export interface IFilter {
	name: string;
	title: string;
	selected: false;
}

export interface IState {
	filterText: string,
	query: string,
	filters: IFilter[],
	selectedTags: string,
	items: IItem[],
	url: string,
	total: number,
	numberToShow: number,
	loading: boolean,
	initialNumberToShow: number,
	sort: ISort[],
	selectedSort: string,
}

const deafultState: IState = {
	filterText: '',
	query: '',
	filters: [],
	selectedTags: '',
	items: [],
	url: '',
	total: 0,
	numberToShow: 12,
	loading: false,
	initialNumberToShow: 12,
	sort: [],
	selectedSort: '',
}

export default deafultState;
